var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-16 -16 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#ff6a10"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5,
    stroke: "#fff",
    d: "M 8 25 C 8 31.544 15.083 35.633 20.75 32.362 C 23.38 30.843 25 28.037 25 25 C 25 18.457 17.916 14.367 12.25 17.639 C 9.62 19.158 8 21.964 8 25 M 25 25 C 25 31.544 32.083 35.633 37.75 32.362 C 40.38 30.843 42 28.037 42 25 C 42 18.457 34.916 14.367 29.25 17.639 C 26.62 19.158 25 21.964 25 25 M 25 5.5 L 25 44.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOp);
export default __webpack_public_path__ + "static/media/op.307d089290090a291002066cd209c4b7.svg";
export { ForwardRef as ReactComponent };